/** @format */

import React, { useMemo } from 'react';
import { Checkbox, FormControlLabel, TextField, Tooltip } from '@material-ui/core';
import i18n from '../../../core/i18n';
import SimpleSelectRest from '../../../components/Adescom/SimpleSelectRest';
import DatePickerForm from '../../../components/Form/DatePickerForm';
import I18n from '../../../components/Translate/I18n';
import { LinearBillingInterface } from '../../../interfaces/billing/LinearBillingInterface';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { DateHelper } from '../../../helpers/DateHelper';
import moment from 'moment';
import BasePricelistInterface from '../../../interfaces/billing/BasePricelistInterface';

interface BasicDataTabPropsInterface {
    linearBilling: LinearBillingInterface;
    pricelist: BasePricelistInterface | null;
    updateLinearBilling: (property: string, value: any) => void;
}

export const BasicDataTab = (props: BasicDataTabPropsInterface): React.ReactElement => {
    const [allowDeactivationDate, setAllowDeactivationDate] = React.useState<boolean>(!!props.linearBilling?.deactivationDate);

    const vatCollections: any = useMemo(() => {
        return {
            'hydra:member': [
                {
                    mainname: '23%',
                    value: '23',
                },
            ],
        };
    }, []);

    const typeCollections: any = useMemo((): any => {
        return {
            'hydra:member': [
                { name: i18n.t('pricelists:lb.type_voice'), value: 0 },
                { name: i18n.t('pricelists:lb.type_service'), value: 1 },
            ],
        };
    }, []);

    return (
        <>
            {props.linearBilling && (
                <>
                    <br />
                    <br />
                    <GridContainer>
                        <GridItem xs={12}>
                            <form noValidate autoComplete="off">
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('pricelists:lb.name')}
                                    style={{ width: '100%' }}
                                    variant="outlined"
                                    value={props.linearBilling?.mainname ?? ''}
                                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
                                        props.updateLinearBilling('mainname', event.target.value ?? '');
                                    }}
                                />
                            </form>
                            <br />
                        </GridItem>
                        <GridItem xs={12}>
                            <SimpleSelectRest
                                callback={(e: any, stateName: string, require: boolean): void => {
                                    //
                                }}
                                restElements={vatCollections}
                                stateName="vat"
                                idState="id"
                                idSelected={'23'}
                                propKey="value"
                                required={false}
                                propValue="mainname"
                                emptyLabel="translation:common.empty_label"
                                label="pricelists:lb.vat"
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <SimpleSelectRest
                                callback={(e: any, stateName: string, require: boolean): void => {
                                    props.updateLinearBilling('type', e.target.value);
                                }}
                                restElements={typeCollections}
                                stateName="type"
                                idState="type"
                                idSelected={props.linearBilling?.type ?? 0}
                                propKey="value"
                                required={false}
                                propValue="name"
                                emptyLabel="translation:common.empty_label"
                                label="pricelists:lb.type"
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <DatePickerForm
                                helpText="pricelists:lb.activedate"
                                defaultValue={props.linearBilling?.activedate ? moment(props.linearBilling?.activedate) : moment()}
                                callback={(moment: any): void => {
                                    props.updateLinearBilling('activedate', typeof moment === 'string' ? moment : moment.format('YYYY-MM-DD'));
                                }}
                                timeFormat={false}
                                dateFormat={'YYYY-MM-DD'}
                                autoComplete={'off'}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <Tooltip title={!props.pricelist ? i18n.t('pricelists:lb.cannot_set_deactivation_date_on_base_pricelist') ?? '' : ''}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={allowDeactivationDate}
                                            disabled={!props.pricelist}
                                            onClick={(): void => {
                                                if (allowDeactivationDate) {
                                                    props.updateLinearBilling('deactivationDate', null);
                                                }
                                                setAllowDeactivationDate(!allowDeactivationDate);
                                            }}
                                            name="allowDeactivationDate"
                                            color="primary"
                                        />
                                    }
                                    label={<I18n trans={'pricelists:lb.allowDeactivationDate'} />}
                                />
                            </Tooltip>
                            <br />
                            {allowDeactivationDate && !props.pricelist?.historicalEvent && (
                                <I18n trans={'pricelists:lb.setting_deactivation_date_changes_base_to_history_pricelist'} />
                            )}
                        </GridItem>
                        <GridItem xs={12}>
                            {allowDeactivationDate && (
                                <DatePickerForm
                                    helpText="pricelists:lb.deactivationDate"
                                    defaultValue={props.linearBilling?.deactivationDate ? moment(props.linearBilling.deactivationDate) : ''}
                                    placeholder="pricelists:lb.deactivationDate"
                                    callback={(moment: any): void => {
                                        props.updateLinearBilling(
                                            'deactivationDate',
                                            typeof moment === 'string' ? new Date(moment) : moment.format('YYYY-MM-DD')
                                        );
                                    }}
                                    timeFormat={false}
                                    dateFormat={'YYYY-MM-DD'}
                                    autoComplete={'off'}
                                />
                            )}
                        </GridItem>
                        <GridItem xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.linearBilling?.strictPrefixMatch ?? false}
                                        onClick={(): void => {
                                            props.updateLinearBilling('strictPrefixMatch', !props.linearBilling?.strictPrefixMatch);
                                        }}
                                        name="strictPrefixMatch"
                                        color="primary"
                                    />
                                }
                                label={<I18n trans={'pricelists:h.strict_prefix_match'} />}
                            />
                        </GridItem>
                    </GridContainer>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </>
            )}
        </>
    );
};
